export class RouteObject {
  routeCommands: any[];
  routeExtras?: any;

  constructor(commands: any[], extras?: any) {
    this.routeCommands = commands;
    this.routeExtras = extras;
  }
}
